import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card } from '../components/ui/display/Card.jsx';
import { tFor } from '../i18n/i18n.js';

// Staff picker. Always includes a "Best available" option as the first
// choice. It sends no staff ID, so the backend can assign the least-booked
// eligible person for that time. Individual options show the CDN-backed
// portrait when the shop has uploaded one.

export function StepStaff({ staff, selectedId, onSelect, locale }) {
  const t = tFor(locale);
  return (
    <Card title={t('staff.heading')}>
      <div className="sp-staff">
        <StaffOption
          selected={selectedId == null}
          onClick={() => onSelect(null)}
          label={t('staff.any')}
          icon={<Sparkles size={22} strokeWidth={2} />}
        />
        {staff.map((member) => (
          <StaffOption
            key={member.id}
            selected={String(selectedId) === String(member.id)}
            onClick={() => onSelect(member.id)}
            label={member.name}
            initials={initials(member.name)}
            photoUrl={member.photoUrl}
          />
        ))}
      </div>
    </Card>
  );
}

function StaffOption({ selected, onClick, label, initials, photoUrl, icon }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`sp-staff__option ${selected ? 'is-selected' : ''}`}
      aria-pressed={selected}
    >
      <span className="sp-staff__avatar">
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={label}
          />
        ) : (
          icon || initials
        )}
      </span>
      <span className="sp-staff__name">{label}</span>
    </button>
  );
}

const initials = (name) =>
  (name || '')
    .split(/\s+/)
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
